import { LoanModel } from 'store/models/LoanModel';
import { atom, selector, selectorFamily } from 'recoil';
import { defaultAddress, MULTICHAIN_SETUP } from 'constants/variables';
import {
  getETHBalance,
  getTotalBalanceByTokenAddress,
} from 'utils/contract/web3';
import { ethers } from 'ethers';
import { ilkToToken } from 'utils/contract/common-function';
import { IUserWallet } from 'store/type';
import { BigNumber } from 'bignumber.js';

export const loanListOriginal = atom<any>({
  key: 'loanListOriginal',
  default: [],
});

export const loanList = selector({
  key: 'loanList',
  get: ({ get }) => {
    const list = get(loanListOriginal);
    return list.map(item => new LoanModel(item));
  },
  set: ({ set }, newValue) => set(loanListOriginal, newValue),
});

export const appContext = atom<any>({
  key: 'appContext',
  default: MULTICHAIN_SETUP.polka,
});

export const userAddress = atom<string>({
  key: 'userAddress',
  default: defaultAddress,
});

/*
 * Maybe better than below
 * We only need set proxy once
 * */
export const proxyAddress = atom<string>({
  key: 'proxyAddress',
  default: ethers.constants.AddressZero,
});

/* This way will run get every time we call */
// export const proxyByAddress = selector({
//   key: 'proxyByAddress',
//   get: async ({ get }) => {
//     const address = get(userAddress)
//     if (!address) {
//       return ethers.constants.AddressZero
//     }
//     return await getProxyAddress(address);
//   }
// })

export const userApprove = atom<boolean>({
  key: 'userApprove',
  default: true,
});

export const userApproveSelector = selector<boolean>({
  key: 'userApproveSelector',
  get: ({ get }) => get(userApprove),
  set: ({ set }, newValue) => set(userApprove, newValue),
});

export const userWallet = selectorFamily<IUserWallet, string>({
  key: 'userWallet',
  get:
    ilk =>
    async ({ get }) => {
      const createToken = ilkToToken(ilk);
      const address = get(userAddress);
      const AppContext = get(appContext);
      if (createToken === 'HLB') {
        const balance = await getETHBalance(address);
        return {
          balance: new BigNumber(balance),
          token: AppContext.nativeSymbol || 'HLB',
        };
      }

      const { balance } = await getTotalBalanceByTokenAddress(
        address,
        AppContext.address[createToken],
        createToken,
      );

      return {
        balance: new BigNumber(balance),
        token: createToken,
      };
    },
});

export const LOAN_DETAIL_STEP = {
  form: '1',
  confirm: '2',
  setupProxy: '3',
};

export const loanStep = atom<string>({
  key: 'loanStep',
  default: LOAN_DETAIL_STEP.form,
});

export const triggerRefresh = atom<number>({
  key: 'triggerRefresh',
  default: 0,
});
